var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannedUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5538_22472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 2.40039C9.3484 2.40039 7.1996 4.54919 7.1996 7.20039V8.00039C7.1996 10.6516 9.3484 12.8004 11.9996 12.8004C14.6508 12.8004 16.7996 10.6516 16.7996 8.00039V7.20039C16.7996 4.54919 14.6508 2.40039 11.9996 2.40039ZM11.998 15.2004C8.79323 15.2004 4.68123 16.9339 3.49803 18.4723C2.76683 19.4235 3.4629 20.8004 4.6621 20.8004H19.3355C20.5347 20.8004 21.2308 19.4235 20.4996 18.4723C19.3164 16.9347 15.2028 15.2004 11.998 15.2004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.9993,
    cy: 18.0002,
    r: 5.80005,
    fill: "#D9D9D9",
    stroke: "#E2E2E8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9992 13.2002C15.3484 13.2002 13.1992 15.3494 13.1992 18.0002C13.1992 20.651 15.3484 22.8002 17.9992 22.8002C20.65 22.8002 22.7992 20.651 22.7992 18.0002C22.7992 15.3494 20.65 13.2002 17.9992 13.2002ZM20.3992 18.4002H15.5992C15.3784 18.4002 15.1992 18.221 15.1992 18.0002C15.1992 17.7794 15.3784 17.6002 15.5992 17.6002H20.3992C20.62 17.6002 20.7992 17.7794 20.7992 18.0002C20.7992 18.221 20.62 18.4002 20.3992 18.4002Z",
    fill: "#DC065F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5538_22472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannedUser);
export default __webpack_public_path__ + "static/media/banned-user.f3f841534777d0a3c5b3c2605a17ad87.svg";
export { ForwardRef as ReactComponent };